import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiX } = FiIcons;

const ComparisonTable = () => {
  const comparisonData = [
    {
      feature: 'Monthly Cost (per user)',
      '3cx': '$15-25',
      ringcentral: '$30-45',
      vonage: '$25-40',
      nextiva: '$28-45',
      zoom: '$25-35',
      spectrum: '$35-50'
    },
    {
      feature: 'Local Support',
      '3cx': true,
      ringcentral: false,
      vonage: false,
      nextiva: false,
      zoom: false,
      spectrum: 'Limited'
    },
    {
      feature: 'Contract Required',
      '3cx': false,
      ringcentral: true,
      vonage: true,
      nextiva: true,
      zoom: true,
      spectrum: true
    },
    {
      feature: 'HIPAA Compliance',
      '3cx': true,
      ringcentral: 'Paid Add-on',
      vonage: 'Paid Add-on',
      nextiva: 'Paid Add-on',
      zoom: 'Paid Add-on',
      spectrum: false
    },
    {
      feature: 'Call Recording Included',
      '3cx': true,
      ringcentral: 'Limited',
      vonage: 'Paid Add-on',
      nextiva: 'Limited',
      zoom: 'Limited',
      spectrum: false
    }
  ];

  const providers = [
    { key: '3cx', name: '3CX', highlight: true },
    { key: 'ringcentral', name: 'RingCentral' },
    { key: 'vonage', name: 'Vonage' },
    { key: 'nextiva', name: 'Nextiva' },
    { key: 'zoom', name: 'Zoom Phone' },
    { key: 'spectrum', name: 'Spectrum' }
  ];

  const renderCell = (value) => {
    if (typeof value === 'boolean') {
      return value ? (
        <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500 mx-auto" />
      ) : (
        <SafeIcon icon={FiX} className="h-5 w-5 text-red-500 mx-auto" />
      );
    }
    return <span className="text-sm">{value}</span>;
  };

  return (
    <section id="comparison" className="py-20 bg-gray-50">
      <div className="w-4/5 mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            How 3CX Stacks Up Against the Competition
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See why businesses are switching from expensive providers to 3CX
          </p>
        </motion.div>

        <motion.div
          className="bg-white rounded-2xl shadow-lg overflow-hidden"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gray-50">
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">
                    Features
                  </th>
                  {providers.map((provider) => (
                    <th
                      key={provider.key}
                      className={`px-6 py-4 text-center text-sm font-semibold ${
                        provider.highlight
                          ? 'bg-primary-600 text-white'
                          : 'text-gray-900'
                      }`}
                    >
                      {provider.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                  >
                    <td className="px-6 py-4 text-sm font-medium text-gray-900">
                      {row.feature}
                    </td>
                    {providers.map((provider) => (
                      <td
                        key={provider.key}
                        className={`px-6 py-4 text-center ${
                          provider.highlight ? 'bg-primary-50' : ''
                        }`}
                      >
                        {renderCell(row[provider.key])}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ComparisonTable;